export const sliderItems = [
    {
        id: 1,
        img: "https://thumbs.dreamstime.com/b/fashion-pretty-cool-young-girl-shopping-bags-wearing-black-hat-white-pants-over-colorful-orange-background-79063329.jpg",
        title: "SUMMER SALE",
        desc: "DON'T COMPROMISE ON STYLE! GET 30% OFF ON NEW ARRIVALS.",
        bg: "f5fafd",
    },
    {
        id: 2,
        img: "https://www.shutterstock.com/image-photo/high-fashion-photo-beautiful-elegant-600w-2076851164.jpg",
        title: "PARTY WEAR COLLECTION",
        desc: "DON'T COMPROMISE ON STYLE! GET 30% OFF ON NEW ARRIVALS.",
        bg: "fcf1ed",
    },
    {
        id: 3,
        img: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8d2ludGVyJTIwZ2lybHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60",
        title: "WINTER COLLECTION",
        desc: "DON'T COMPROMISE ON STYLE! GET 30% OFF ON NEW ARRIVALS.",
        bg: "fbf0f4",
    },
];

export const categories = [
    {
        id: 1,
        img: "https://img.freepik.com/free-photo/portrait-handsome-smiling-stylish-young-man-model-dressed-red-checkered-shirt-fashion-man-posing_158538-4909.jpg?w=740&t=st=1662831506~exp=1662832106~hmac=3502356175612df11810cd0d56516e59e5dd7442e5aa1e55176532dfd6cb62c8",
        title: "SHIRT STYLE!",
    },
    {
        id: 2,
        img: "https://img.freepik.com/free-photo/wonderful-woman-with-curly-short-hairs-listen-favorite-music-lying-with-closed-eyes-with-pleasure-wearing-cute-pink-loungewear_273443-2791.jpg?w=740&t=st=1662831423~exp=1662832023~hmac=b74a9f166e9b4beee2d56aafd171714b271b0c72fe7f43a129f225fae63c8403",
        title: "LOUNGEWEAR LOVE",
    },
    {
        id: 3,
        img: "https://img.freepik.com/free-photo/young-irl-wearing-black-bra-leather-jacket-while-sitting-balcony-high-quality-photo_144627-75775.jpg?w=360&t=st=1662831575~exp=1662832175~hmac=544a935d713510973aef61747b068b4f01f278687a57446bce3d91f96431bc49",
        title: "LIGHT JACKETS",
    },
];

export const popularProducts = [
    {
      id:1,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:2,
      img:"https://png.pngtree.com/png-clipart/20220815/ourmid/pngtree-mens-solid-red-polo-shirt-for-clothing-model-mockup-and-passport-png-image_6110903.png",
    },
    {
      id:3,
      img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    },
    {
      id:4,
      img:"https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
    },
    {
      id:5,
      img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
      id:6,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
    },
    {
      id:7,
      img:"https://png.pngtree.com/png-clipart/20211209/ourmid/pngtree-mens-black-suit-formal-id-photo-png-image_4053965.png",
    },
    {
      id:8,
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
  ]